import { Navigate, Route, Routes } from 'react-router-dom';

import '../../estilos/vencimientos.css';
import ConfiguracionDeVencimientos from './pantallas/ConfiguracionDeVencimientos.jsx';
import DetalleDelVencimiento from './pantallas/DetalleDelVencimiento.jsx';
import PanelDeVencimientos from './pantallas/PanelDeVencimientos.jsx';
import ReconciliacionDeDiferido from './pantallas/ReconciliacionDeDiferido.jsx';

/**
 * Módulo del incremento 6/6 · Panel de vencimientos (RF-122, D-185).
 *
 * EL 6/6 NO REGISTRA SECCIÓN DE NAVEGACIÓN Y EL SHELL NO SE TOCA: no llama a
 * `registrarSeccion`, no reclama lugar en la barra inferior y no desplaza a nadie al
 * menú secundario. La barra sigue con sus cinco lugares de módulo y el sexto de
 * Ajustes (RN-044b, RN-044c). Calca lo que hizo el 4/6 con la pestaña «Meses».
 *
 * SU SITIO PROPIO ES LA PESTAÑA «VENCIMIENTOS» DEL DESTINO CUENTAS, y por eso el
 * módulo recibe su `base`: montado bajo `/cuentas/vencimientos` es esa pestaña, y
 * montado bajo `/vencimientos` atiende el destino que el núcleo ya tenía registrado
 * desde el 1/6. Las dos rutas pintan LO MISMO y consumen LA MISMA operación: si
 * mostraran importes o estados distintos, sería defecto (RN-278).
 *
 * TRES PANTALLAS, LAS DEL PROTOTIPO v21:
 *   · `{base}`                 panel completo, con `incluirSinSaldo = true`.
 *   · `{base}/:idCuenta`       detalle del vencimiento de una tarjeta.
 *   · `{base}/configuracion`   días de anticipación del aviso.
 * La cuarta pantalla del prototipo es el BLOQUE DEL TABLERO, que no es una ruta:
 * es el componente `BloqueDeVencimientosDelTablero`.
 */
export default function Vencimientos({ base = '/cuentas/vencimientos' }) {
  return (
    <Routes>
      <Route index element={<PanelDeVencimientos base={base} />} />
      <Route path="configuracion" element={<ConfiguracionDeVencimientos base={base} />} />
      {/* [NUEVO · incremento 19/21 · RF-259] La comparación entre lo declarado y
          los planes reales. Va ANTES de `:idCuenta` a propósito: si fuera después,
          la ruta de parámetro se la comería y «comparacion» acabaría pidiendo el
          detalle de una tarjeta inexistente. */}
      <Route path="comparacion" element={<ReconciliacionDeDiferido />} />
      <Route path=":idCuenta" element={<DetalleDelVencimiento base={base} />} />
      <Route path="*" element={<Navigate to={base} replace />} />
    </Routes>
  );
}
